var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOilBarrel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C6.44772 2 6 2.44772 6 3C6 3.55228 6.44772 4 7 4H8V36H7C6.44772 36 6 36.4477 6 37C6 37.5523 6.44772 38 7 38H33C33.5523 38 34 37.5523 34 37C34 36.4477 33.5523 36 33 36H32V4H33C33.5523 4 34 3.55228 34 3C34 2.44772 33.5523 2 33 2H7ZM10 6V4H30V6H10ZM10 8H30V32H10V8ZM10 36V34H30V36H10ZM20 14L20.7071 13.2929L20.7091 13.2948L20.7124 13.2983L20.7235 13.3094L20.7621 13.3489C20.7949 13.3827 20.8416 13.4312 20.9001 13.4933C21.017 13.6176 21.1818 13.7968 21.3784 14.0222C21.7707 14.4717 22.2949 15.1103 22.8209 15.8664C23.8407 17.3323 25 19.4246 25 21.5C25 24.4236 22.8689 27 20 27C17.1311 27 15 24.4236 15 21.5C15 19.4246 16.1593 17.3323 17.1791 15.8664C17.7051 15.1103 18.2293 14.4717 18.6216 14.0222C18.8182 13.7968 18.983 13.6176 19.0999 13.4933C19.1584 13.4312 19.2051 13.3827 19.2379 13.3489L19.2765 13.3094L19.2876 13.2983L19.2909 13.2948L19.2929 13.2929L20 14ZM20 14C20.7071 13.2929 20.7069 13.2927 20.7071 13.2929C20.3166 12.9024 19.6834 12.9024 19.2929 13.2929C19.2931 13.2927 19.2929 13.2929 20 14ZM18.8209 17.0086C19.2401 16.4059 19.6609 15.8824 20 15.4859C20.3391 15.8824 20.7599 16.4059 21.1791 17.0086C22.1593 18.4177 23 20.0754 23 21.5C23 23.547 21.5494 25 20 25C18.4506 25 17 23.547 17 21.5C17 20.0754 17.8407 18.4177 18.8209 17.0086Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilBarrel);
export default __webpack_public_path__ + "static/media/oil-barrel.98c7d6bbc960bbd8f2d5b3fed7bfa173.svg";
export { ForwardRef as ReactComponent };